import apiClient from '@/utils/request'
import {
  IPaymentProfileAttributes,
  IPaymentProfileResponse
} from '@/interfaces/paymentProfiles'

export const saveProfile = async (
  params: IPaymentProfileAttributes
): Promise<IPaymentProfileResponse> => {
  const response = await apiClient.post<IPaymentProfileResponse>(
    '/payment_profiles',
    params
  )
  return response.data
}

export const fetchProfile = async (
  sid: string
): Promise<IPaymentProfileResponse> => {
  const response = await apiClient.get<IPaymentProfileResponse>(
    `/payment_profiles/${sid}`
  )
  return response.data
}
